export const ADD_AD = "ADD_AD";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const GET_ADS = "GET_ADS";
export const UPDATE_ADD = "UPDATE_ADD";
